import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

import ArrowDark from "../../images/icons/arrow-dark.svg"

const ArrowImg = styled.div`
  background: url(${ArrowDark});
  width: 18px;
  height: 10px;
  margin-right: 16px;
`

const Container = styled(Link)`
  position: relative;
  padding: 32px;
  color: ${props => props.theme.shade[0]};
  text-decoration: none;
  background: ${props => props.theme.hue[90]};
  transition: 0.4s;
  :hover {
    transform: scale(1.02);
    cursor: pointer;
  }
`

const Title = styled.h3`
  font-weight: 600;
  word-break: break-word;
`
const ReadMore = styled.div`
  display: flex;
  align-items: center;
  p {
    margin: 0;
  }
`

export default function NewsArticle(props) {
  return (
    <Container to={props.to} data-sal="fade" data-sal-duration="600">
      <Title>{props.title}</Title>
      <ReadMore>
        <ArrowImg />
        <p>Read More</p>
      </ReadMore>
    </Container>
  )
}
